/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var XIcon24Solid = forwardRef('XIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M3.94 3.94a1.5 1.5 0 0 1 2.12 0L12 9.878l5.94-5.94a1.5 1.5 0 0 1 2.12 2.122L14.122 12l5.94 5.94a1.5 1.5 0 0 1-2.122 2.12L12 14.122l-5.94 5.94a1.5 1.5 0 0 1-2.12-2.122L9.878 12l-5.94-5.94a1.5 1.5 0 0 1 0-2.12Z" })));
});
